import { createReducer, on } from '@ngrx/store';
import {
  CreatedVendorEvent,
  GotAllVendorsEvent,
  GotVendorByDocumentEvent,
  UpdatedVendorEvent,
  UpdatedStateVendorEvent,
} from './vendor.events';
import { VendorState } from './vendor.state';

export const vendorKey = 'vendor';
export const initialState: VendorState = {
  entities: {},
  byQuery: {},
};

export const VendorReducer = createReducer(
  initialState,
  // Replace entities for getAll
  on(GotAllVendorsEvent, (state, { entities }) => ({
    ...state,
    entities: entities.reduce((acc, entity) => ({ ...acc, [entity.id]: entity }), {}),
  })),
  // Replace entities for document search (filter view)
  on(GotVendorByDocumentEvent, (state, action: any) => {
    const entity = action.entity || (action.entities && action.entities[0]);
    if (!entity) return { ...state, entities: {} };
    return {
      ...state,
      entities: { [entity.id]: entity },
    };
  }),
  // Merge for single entity operations
  on(CreatedVendorEvent, UpdatedVendorEvent, UpdatedStateVendorEvent, (state, action: any) => {
    const entity = action.entity || (action.entities && action.entities[0]);
    if (!entity) return state;
    return {
      ...state,
      entities: { ...state.entities, [entity.id]: entity },
    };
  }),
);
